import React from 'react';
import ChatInterface from './ChatInterface';
import './ChatPage.css';

const ChatPage = ({ navigateTo }) => {
  return (
    <div className="chat-page">
      <ChatInterface navigateTo={navigateTo} />
    </div>
  );
};

export default ChatPage; 